(function () {
  'use strict';

  function initReviews(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    var dialog = root.querySelector('[data-review-dialog]');
    var open = root.querySelector('[data-review-open]');
    var close = root.querySelector('[data-review-close]');
    var form = root.querySelector('[data-review-form]');
    var statuses = root.querySelectorAll('[data-review-status]');
    var status = statuses[statuses.length - 1];

    open?.addEventListener('click', function () {
      dialog?.showModal();
    });
    close?.addEventListener('click', function () {
      dialog?.close();
    });
    dialog?.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    form?.addEventListener('submit', async function (event) {
      event.preventDefault();
      var endpoint = root.dataset.submissionEndpoint;
      if (!endpoint) {
        if (status) status.textContent = 'Review submission is not available yet.';
        return;
      }

      var submit = form.querySelector('[type=submit]');
      submit.disabled = true;
      if (status) status.textContent = 'Submitting your review…';

      try {
        var body = new FormData(form);
        body.set('product_id', root.dataset.productId);
        body.set('service_handle', root.dataset.serviceHandle);
        body.set('review_token', new URLSearchParams(location.search).get('review_token') || body.get('review_token') || '');
        var response = await fetch(endpoint, { method: 'POST', body: body, headers: { Accept: 'application/json' } });
        var result = await response.json();
        if (!response.ok) throw new Error(result.message || 'Unable to submit your review.');
        form.reset();
        if (status) status.textContent = result.message || 'Thank you. Your review has been submitted for approval.';
        setTimeout(function () {
          dialog.close();
        }, 1800);
      } catch (error) {
        if (status) status.textContent = error.message || 'Unable to submit your review.';
      } finally {
        submit.disabled = false;
      }
    });
  }

  function initFaq(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var items = [...root.querySelectorAll('details')];
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function initCta(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    root.querySelectorAll('[data-cta-action]').forEach(function (control) {
      control.addEventListener('click', function (event) {
        var action = control.dataset.ctaAction;
        if (action === 'open_slot') {
          event.preventDefault();
          window.Naxarly?.SlotSelector?.open();
        }
        if (action === 'scroll_packages') {
          event.preventDefault();
          document.querySelector('[data-nps]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (action === 'open_event') {
          event.preventDefault();
          document.querySelector('[data-neb] [data-details-toggle]')?.click();
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-naxarly-reviews]').forEach(initReviews);
    document.querySelectorAll('[data-naxarly-faq]').forEach(initFaq);
    document.querySelectorAll('[data-naxarly-cta]').forEach(initCta);
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', boot);
})();
